<template>
    <div role="tabcard" class="tab-pane" id="change-orders">
        <change-orders-list :role="role" :user="user" :project="project"></change-orders-list>
    </div>
</template>

<script>
    export default {
        props: ['role', 'user', 'project'],

        created: function() {
        },

        mounted: function() {

        },

        data: function() {
            return {
            };
        },

        watch: {
        },

        computed: {
            
        },

        methods: {
        }
    }
</script>
